import React from "react";

function FieldError({ message }) {
  if (!message) {
    return null;
  }

  return <label className="form-error-text">{message}</label>;
}

export default FieldError;
